import {
  ShareTradeSettingResponse,
  UpdateSettingRequestBody,
  UpdateSettingResponse,
} from 'typings/api/shareTradeSetting';
import {
  PostShareRequestBody,
  PostShareResponse,
} from 'typings/api/shareTradeShare';
import {
  ShareTradeTargetParams,
  ShareTradeTargetResponse,
  UpdateTargetRequestBody,
  UpdateTargetResponse,
} from 'typings/api/shareTradeTarget';
import { APIResponse } from '../../../../@types/api-response';
import exodusInstance from '../instances/exodus';
import shareTradeEndpoints from './endpoints';

const { defaultInstance } = exodusInstance;
const { setting, settingAutoShare, target, share } = shareTradeEndpoints;

export const getShareTradeSetting = async (): Promise<
  APIResponse<ShareTradeSettingResponse>
> => defaultInstance.get(setting);

export const putShareTradeSetting = async (
  requestBody: UpdateSettingRequestBody,
): Promise<UpdateSettingResponse> =>
  defaultInstance.put(settingAutoShare, requestBody);

export const getShareTradeTarget = async (
  params: ShareTradeTargetParams,
): Promise<APIResponse<ShareTradeTargetResponse>> =>
  defaultInstance.get(target, { params });

export const putShareTradeTarget = async (
  requestBody: UpdateTargetRequestBody,
): Promise<UpdateTargetResponse> => defaultInstance.put(target, requestBody);

export const postShareTradeShare = async (
  requestBody: PostShareRequestBody,
): Promise<PostShareResponse> => defaultInstance.post(share, requestBody);
